import { getUser } from '@frontend/auth-helpers';
import { useScopedAppFlagStore } from '@frontend/scope';
import { AIR_FEATURE_FLAGS } from '../constants';

const DEMO_ACCOUNT_SUFFIX = ['@demoweave.com'];

export const useCheckAiReceptionistDemoAccount = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isDemoModeFlagActive = getFeatureFlagValue(AIR_FEATURE_FLAGS.DEMO_MODE);
  const user = getUser();

  return isDemoModeFlagActive || DEMO_ACCOUNT_SUFFIX.some((suffix) => user?.username?.endsWith(suffix));
};
